import { clientPublic } from 'helper/axios'

export const getPathForgotPasswordInternal = async ( email ) => {
  try {
    return await clientPublic
      .get(`adfs/forgoturl/${email}`)
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
